module.exports = __webpack_public_path__ + "img/LDSJ_STILL13.397e90dc.jpg";